import { type FC } from 'react';
import { useDispatch } from 'react-redux';

import { acceptBothChanges } from '@editor2/reducers/editor/editorSlice';
import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import AcceptButton from './AcceptButton';

interface Props {
	courseId: number;
	conflict: Conflict | ReorderConflict;
	showButton: boolean;
}

const MergedChangesDivider: FC<Props> = (props) => {
	const { courseId, conflict, showButton } = props;

	const dispatch = useDispatch();

	const keepBothChangesTooltip =
		'Retain both changes for subsequent manual editing prior to saving';

	const onAcceptBothClick = () => {
		dispatch(acceptBothChanges({ courseId, conflict }));
	};

	return (
		<div className="changesDivider">
			<span className="divider-text">[ Merged change ]</span>

			{showButton && (
				<AcceptButton
					name="Keep both changes"
					variant="outline-danger"
					tooltip={keepBothChangesTooltip}
					onAcceptClick={() => onAcceptBothClick()}
				/>
			)}
		</div>
	);
};

export default MergedChangesDivider;
